import { useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import { approvePostOrComment, fetchPostApproveList } from "../../api/community";
import { Button, Pagination, Table, Flex, Select, Space, Input, Tag, message, Image } from "antd";
import { useDebouncedCallback } from "use-debounce";
import dayjs from "dayjs";
import { RichText } from "@chatui/core";
import '../../style/community.css';
import PostReview from "../../components/community/post_review";
import UserInfoView from "../../components/community/user_info_view";
import PostApproveRecordsModal from "./post_approve_records_modal";

const PostApprovePageView = ({ isPost }) => {
    const location = useLocation();
    const tabCols = [
        {
            title: 'Created',
            dataIndex: 'createdAt',
            key: 'createdAt',
            render: (text, _) => {
                return <label style={{ fontSize: 12, color: '#afafaf', whiteSpace: 'nowrap' }}>{dayjs(text).format('MM-DD HH:mm')}</label>
            },
        },
        {
            title: 'Post Id',
            dataIndex: 'postId',
            key: 'postId',
            render: (_, record) => {
                const { id } = record.post;
                return <div style={{ fontSize: 12 }}>{id}</div>
            },
        },
        {
            title: 'Title',
            dataIndex: 'title',
            key: 'title',
            render: (_, record) => {
                const { title } = record.post;
                let updatedTitle = title;
                if(record.title) {
                    updatedTitle = record.title;
                }
                if (!updatedTitle) return '-';
                return <div style={{ width: 100 }}><b>{updatedTitle}</b></div>
            },
        },
        {
            title: 'Author',
            dataIndex: 'author',
            key: 'author',
            render: (_, record) => {
                return <UserInfoView user={record.post?.user} showWallet={false} />
            },
        },
        {
            title: 'Content',
            dataIndex: 'content',
            key: 'content',
            render: (_, record) => {
                const { content, title } = record.post;
                let updatedContent = content;
                if(record.content) {
                    updatedContent = record.content;
                }

                let updatedTitle = title;
                if(record.title) {
                    updatedTitle = record.title;
                }
                return (
                    <div style={{ background: '#f1f1f1', padding: '8px 12px', borderRadius: 8, width: 160 }}>
                        <div className="community-content">
                            <RichText content={updatedContent ? updatedContent : updatedTitle} />
                        </div>
                    </div>
                )
            },
        },
        {
            title: 'NLP Result',
            dataIndex: 'nlpResult',
            key: 'nlpResult',
            render: (text, _) => {
                if(!text) return '';
                const nlps = JSON.parse(text);
                return (
                    <Space size={1} wrap>
                        {nlps.map((item, index) => {
                            return <Tag key={index}>{item.name}: <b>{item.confidence}</b></Tag>
                        })}
                    </Space>
                )
            },
        },
        {
            title: 'Status',
            dataIndex: 'status',
            key: 'status',
            render: (text, _) => {
                if (text === 'ApprovePending') {
                    return <Tag color="blue" style={{ fontSize: 12 }}>{text}</Tag>;
                } else if (text === 'ApproveApproved') {
                    return <Tag color="green" style={{ fontSize: 12 }}>{text}</Tag>;
                } else if (text === 'ApproveReject') {
                    return <Tag color="red" style={{ fontSize: 12 }}>{text}</Tag>;
                }
            },
        },
        {
            title: 'Reviewer',
            dataIndex: 'user',
            key: 'user',
            render: (text, _) => {
                if(!text || !text.userId) return '';
                return <UserInfoView user={text} showWallet={false} />
            },
        },
        {
            title: 'Review Time',
            dataIndex: 'updatedAt',
            key: 'updatedAt',
            render: (text, _) => {
                if(!text) return '';
                return <label style={{ fontSize: 12, color: '#afafaf', whiteSpace: 'nowrap' }}>{dayjs(text).format('MM-DD HH:mm')}</label>
            },
        },
        {
            title: 'Review Records',
            dataIndex: 'record',
            key: 'record',
            render: (_, record) => {
                return (
                    <Button onClick={() => toApprovalModal(record)} type="text" size="small" style={{fontSize: 11, color: 'blue', padding: 0}}>Check Records</Button>
                )
            },
        },
        {
            title: 'Action',
            dataIndex: 'action',
            key: 'action',
            fixed: 'right',
            render: (_, record) => {
                return (
                    <Button.Group size='small'>
                        <Button type='link' onClick={() => { reviewHandle(record) }}>Review</Button>
                        {
                            record.isLatest && record.status === 'ApprovePending' && (
                                <>
                                    <Button type='link' onClick={() => { postHandle(record, 1) }}>Approve</Button>
                                    <Button danger type='link' onClick={() => { postHandle(record, 2) }}>Reject</Button>
                                </>
                            )
                        }
                    </Button.Group>
                )
            },
        }
    ];

    const [searchParams, setSearchParams] = useState({
        postCategory: isPost ? 'post' : 'article',
        status: '',
        userId: ''
    });
    const [tabData, setTabData] = useState([]);
    const [pageNum, setPageNum] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [total, setTotal] = useState(0);
    const [loading, setLoading] = useState(false);
    const [open, setOpen] = useState(false);
    const [currPost, setCurrPost] = useState();
    const [selectedRows, setSelectedRows] = useState();
    const [approvalModal, setApprovalModal] = useState(false);

    useEffect(() => {
        fetchData(pageNum, pageSize, searchParams);
    }, [location])

    const fetchData = (pNum, pSize, search) => {
        setLoading(true);
        let params = {
            'page.num': pNum,
            'page.size': pSize,
            ...search,
        };
        fetchPostApproveList(params).then(res => {
            if (res.page) {
                setTotal(res.page.total);
            }
            if (res.list) {
                setTabData(res.list);
            }
        }).finally(() => setLoading(false))
    }

    const pageChange = (page, size) => {
        setPageNum(page);
        setPageSize(size);
        fetchData(page, size, searchParams);
    }

    const toApprovalModal = (record) => {
        setCurrPost(record.post);
        setApprovalModal(true);
    }

    const onSearchChange = useDebouncedCallback(
        (tag, value) => {
            let newParams = { ...searchParams };
            if (tag === 'dates') {
                if (value.length == 2) {
                    newParams.gteCreatedAt = `${value[0]}T00:00:00Z`;
                    newParams.ltCreatedAt = `${value[1]}T23:59:59Z`;
                } else {
                    newParams.gteCreatedAt = '';
                    newParams.ltCreatedAt = '';
                }
            } else {
                newParams[tag] = value;
            }
            setSearchParams(newParams);
            setPageNum(1);
            fetchData(1, pageSize, newParams);
        },
        300
    )

    const postHandle = (record, status) => {
        setLoading(true);
        let params = { list: [{ id: record.id, status: status }] };
        approvePostOrComment(params).then(res => {
            if (res) {
                fetchData(pageNum, pageSize, searchParams);
                setSelectedRows([])
            }
        }).catch(err => {
            message.error(String(err));
        }).finally(() => {
            setLoading(false);
        });
    }

    const reviewHandle = (record) => {
        let post = {...record.post};
        if(record.content) {
            post.content = record.content;
        }
        if(record.title) {
            post.title = record.title;
        }
        if(record.resources && record.resources.length > 0) {
            post.resources = record.resources;
        }

        setCurrPost(post);
        setOpen(true);
    }

    const approvalBatch = (status) => {
        setLoading(true);
        let params = {
            list: selectedRows.map(item => {
                return { id: item.id, status: status }
            })
        };
        approvePostOrComment(params).then(res => {
            if (res) {
                fetchData(pageNum, pageSize, searchParams);
                setSelectedRows([])
            }
        }).catch(err => {
            message.error(String(err));
        }).finally(() => {
            setLoading(false);
        });
    }

    return (
        <div className='main-wrapper'>
            <div className='top-part cnt-item'>
                <Flex justify="space-between">
                    <Space>
                        {
                            (selectedRows && selectedRows.length > 0) && (
                                <>
                                    <Button onClick={() => approvalBatch(1)} type="primary">Batch Approve</Button>
                                    <Button onClick={() => approvalBatch(2)} danger type="primary">Batch Reject</Button>
                                </>
                            )
                        }
                        <div />
                    </Space>

                    <Space wrap style={{ justifyContent: 'flex-end' }}>
                        <Select
                            style={{ width: 160 }}
                            options={[
                                { key: 1, label: 'Pending', value: '0' },
                                { key: 2, label: 'Approved', value: '1' },
                                { key: 3, label: 'Rejected', value: '2' },
                            ]}
                            placeholder='Approve status'
                            onChange={value => onSearchChange('status', value)}
                            allowClear
                        />
                        <Input
                            placeholder="username"
                            allowClear
                            onChange={evt => onSearchChange('userId', evt.target.value)}
                        />
                    </Space>
                </Flex>
            </div>
            <div className='cnt-item'>
                <Table
                    scroll={{ x: true }}
                    loading={loading}
                    rowKey={(record) => record.id}
                    rowClassName={'table-row'}
                    size='small'
                    dataSource={tabData}
                    columns={tabCols}
                    pagination={false}
                    rowSelection={{
                        selectedRowKeys: (selectedRows ?? []).map(item => item.id),
                        getCheckboxProps: (record) => ({
                            disabled: (record.status !== 'ApprovePending' || !record.isLatest),
                        }),
                        onChange: (keys, rows) => {
                            setSelectedRows(rows);
                        }
                    }} />
            </div>
            <div className='footer-part cnt-item'>
                <Pagination
                    total={total}
                    showTotal={(total) => `total ${total}`}
                    current={pageNum}
                    pageSize={pageSize}
                    showSizeChanger={true}
                    pageSizeOptions={[10, 20, 30, 50]}
                    onChange={(page, size) => pageChange(page, size)}
                />
            </div>

            <PostReview
                from={isPost ? 'community_post_approval' : 'community_article_approval'}
                open={open}
                post={currPost}
                onClose={() => setOpen(false)}
                onUpdate={() => fetchData(pageNum, pageSize, searchParams)}
            />

            <PostApproveRecordsModal
                modalOpen={approvalModal}
                postId={currPost?.id}
                onClose={() => setApprovalModal(false)} />
        </div>
    )
}

export default PostApprovePageView;